export default "__VITE_ASSET__JYtnrp3t__"